import { ReactNode } from "react";
import { MiStackedTypography } from "@miplatform/components";
import { TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { useTheme } from "@mui/material";

export const Info = ({
  text = "",
  subtext = "",
  maxWidth = 120,
  descriptionColor,
  descriptionsProps,
}: {
  text?: string;
  subtext?: ReactNode;
  maxWidth?: number;
  descriptionColor?: string;
  descriptionsProps?: Record<string, unknown>;
}) => {
  const theme = useTheme();

  return (
    <MiStackedTypography
      title={text}
      titleFontSize={11}
      titleProps={{
        variant: TYPOGRAPHY_VARIANTS.BODY2,
      }}
      description={subtext}
      descriptionFontSize={12}
      descriptionProps={{
        color: descriptionColor ?? theme.palette.text.primary,
        maxWidth,
        fontWeight: theme.fontWeight.semiBold,
        ...descriptionsProps,
      }}
    />
  );
};
